import React from "react";
import { Redirect } from "react-router-dom";
import MenuAdmin from "../../../pages/nf-invoice/menu-admin";
import Navbar from "../../navbar";
import { CenterContent, ContainerStyled, ContentStyled } from "./styles";
import { LoadingScreen } from "../../ui/loading";
import { useAuthGlobal } from "../../../../contexts/auth-context/auth-context";

const AdminBaseLayout = ({ children }: any): JSX.Element => {
  const { user, isLoading } = useAuthGlobal();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Redirect to="/admin" />;
  }

  const menu: any = <MenuAdmin />;
  return (
    <ContainerStyled>
      {menu}
      <ContentStyled>
        <Navbar />
        <CenterContent>{children}</CenterContent>
      </ContentStyled>
    </ContainerStyled>
  );
};

export default AdminBaseLayout;
